const Layout = () => import(/* webpackChunkName: "base" */'@/components/common/Layout');
const DesignModel = () => import(/* webpackChunkName: "workflow" */'@/components/pages/workflow/DesignModel');
const ConfigWorkbench = () => import(/* webpackChunkName: "requestConfig" */'@/components/pages/requestConfig/Workbench');
const EntryOperate = () => import(/* webpackChunkName: "requestConfig" */'@/components/pages/requestConfig/EntryOperate');

import slaManage from './slaManage';
import requetConfig from './requetConfig';
import essential from './essential';
import notice from './notice';
import flow from './flow';
import business from './business';

export default [
  {
    path: '/system',
    name: 'system',
    component: Layout,
    meta: {
      title: '系统管理',
      icon: 'system',
      roles: [
        'SYS_USER_QUERY',
        'SYS_ROLE_QUERY',
        'SYS_DEPART_QUERY',
        'SYS_SUP_GROUP_QUERY',
        'SYS_CATEGORY_QUERY',
        'SYS_DIC_QUERY',
        'SYS_NOTICE_MEDIUM_QUERY',
        'SYS_NOTICE_TEMPLATE_QUERY',
        'SYS_NOTICE_RECORD_QUERY',
        'SYS_NOTICE_CONFIG_QUERY',
        'WF_MNG_MODELS_QUERY',
        'WF_MNG_DEPLOY_QUERY',
        'WF_MNG_DEFINITION_QUERY',
        'WF_MNG_QUERY',
        'WF_EVENT_TEMPLATES_QUERY',
        'SYS_ORDER_NUM_RULES_QUERY',
        'SYS_ANNOUNCEMENT_QUERY',
        'SYS_CONFIG_QUERY',
        'BUSINESS_RULE_QUERY',
        'CLASS_ATTRIBUTE_QUERY',
        'CLASS_ATTRIBUTE_RELATIONS_QUERY',
        'WF_AUTO_DISPATCH_QUERY'
      ]
    },
    children: [
      ...essential,
      ...notice,
      ...flow,
      ...business,
      ...slaManage,
      {
        path: 'request-config/config-bench',
        name: 'configBench',
        meta: {
          roles: ['SERVICE_CATALOG_QUERY'],
          title: '请求目录配置',
          icon: 'service',
          activeMenu: '/request-config/config-bench',
          componentName: 'ConfigWorkbench',
          breadcrumb: [
            {
              name: '请求目录配置',
              path: '/request-config/request-bench'
            }
          ]
        },
        component: ConfigWorkbench
      },
      {
        path: 'request-config/create-entry/:serviceCatalogId',
        name: 'createEntry',
        meta: {
          roles: ['SERVICE_ENTRY_CREATE'],
          title: '新建请求条目',
          hidden: true,
          activeMenu: '/request-config/config-bench',
          componentName: 'EntryOperate',
          breadcrumb: [
            {
              name: '新建请求条目',
              path: '/request-config/create-entry/:serviceCatalogId'
            }
          ]
        },
        component: EntryOperate
      },
      {
        path: 'request-config/eidt-entry/:id',
        name: 'editEntry',
        meta: {
          roles: ['SERVICE_ENTRY_DETAIL'],
          title: '编辑请求条目',
          hidden: true,
          activeMenu: '/request-config/config-bench',
          componentName: 'EntryOperate',
          breadcrumb: [
            {
              name: '编辑请求条目',
              path: '/request-config/eidt-entry/:id'
            }
          ]
        },
        component: EntryOperate
      }
    ]
  },
  {
    path: '/system/flow-center/design-model/:id',
    name: 'designModel',
    props: true,
    component: DesignModel,
    meta: {
      roles: ['WF_MNG_MODELS_DESIGN'],
      componentName: 'DesignModel',
      hidden: true
    }
  },
];



// WEBPACK FOOTER //
// ./src/router/system.js